<template>
  <div>
  </div>
</template>

<script>
import { vuexOidcProcessSilentSignInCallback } from 'vuex-oidc'
import { oidcSettings } from '@/config/oidc'

// Loaded inside oidc-client-ts's hidden iframe when a silent renew has to fall back to the
// authorize endpoint (no refresh token). It only relays the response to the parent window —
// no app UI must render here.
export default {
  name: 'OidcSilentRenew',
  mounted () {
    vuexOidcProcessSilentSignInCallback(oidcSettings)
  }
}
</script>
